module.exports = __webpack_public_path__ + "static/media/tier-10.e3feb6ed.jpg";